import { keyframes, css } from 'styled-components'
import { CssAnimationProps } from 'animations'

const inTo = keyframes`
  0% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(0);
  }
  80% {
    transform: translateY(-3%);
  }
`

const animation = css<CssAnimationProps>`
  animation: ${inTo} ${({ animationDuration }) => animationDuration || '.7s'} ease-out;
  transition-property: transform;
`

export default animation
